
import React from 'react';
import { Cascader } from 'antd';
import { useMemo } from 'react'
import useChannels from '../../../../hooks/useChannel'


// Just show the latest item.
function displayRender(label) {
    return label[label.length - 1];
}

function channel2node(channel) {
    return { label: channel.channel_name, value: channel.id }
}

export default ({ handleChange }) => {
    const [channels] = useChannels({ page_no: 1, page_size: 99999999 })
    const options = useMemo(() => {

        const channel_type1 = channels.filter(item => item.channel_type == 1)
        const channel_type2 = channels.filter(item => item.channel_type == 2)
        const channel_type3 = channels.filter(item => item.channel_type == 3)

        return [
            {
                value: '',
                label: '全部',
            },
            {
                value: '1',
                label: '公众号',
                disabled: channel_type1.length === 0,
                children: channel_type1.map(channel2node),
            },
            {
                value: '2',
                label: '抖音',
                disabled: channel_type2.length === 0,
                children: channel_type2.map(channel2node),
            },
            {
                value: '3',
                label: '艺龙顶楼',
                disabled: channel_type3.length === 0,
                children: channel_type3.map(channel2node),
            },
        ]
    }, [channels])

    const onChange = (values => {
        handleChange({
            target: {
                value: values[values.length - 1] && values[values.length - 1] + "" || ""
            }
        })

    })

    return <Cascader style={{ width: '70%' }} options={options} displayRender={displayRender} onChange={onChange} />
}